import { laceOfVerticalPartsRight } from './parts/laceParts'
import { topSidePartOfWeb } from './parts/sideParts'
import { drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

export const flatVLaceWeb = async (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  laceColor: string,
  stitchColor: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'

  // ウェブ本体
  const drawMainPath = () => {
    ctx.beginPath()
    ctx.moveTo(300, 376) // 左下
    ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
    ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
    ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
    ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawMainPath, webColor)

  // ウェブ先端
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)

  // stitchここから
  ctx.lineWidth = 1.1
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  //
  ctx.moveTo(262, 195) // 左上
  ctx.quadraticCurveTo(282, 205, 282, 205) // 下
  ctx.quadraticCurveTo(281, 174, 281, 174) // 右下
  //
  ctx.moveTo(255, 210) // 左上
  ctx.quadraticCurveTo(295, 226, 295, 226) // 下
  ctx.quadraticCurveTo(294, 160, 294, 160) // 右下
  //
  ctx.moveTo(248, 219) // 左上
  ctx.quadraticCurveTo(304, 243, 304, 243) // 下
  ctx.quadraticCurveTo(307, 143, 307, 143) // 右下
  //
  ctx.moveTo(238, 239) // 左上
  ctx.quadraticCurveTo(316, 268, 316, 268) // 下
  ctx.quadraticCurveTo(321, 132, 321, 132) // 右下
  //
  ctx.moveTo(232, 259) // 左上
  ctx.quadraticCurveTo(330, 292, 330, 292) // 下
  ctx.quadraticCurveTo(337, 135, 337, 135) // 右上
  ctx.quadraticCurveTo(345, 179, 345, 179) //
  ctx.quadraticCurveTo(345, 296, 345, 296) //
  //
  ctx.moveTo(244, 280) // 左上
  ctx.quadraticCurveTo(340, 324, 340, 324) // 下
  // ギザギザデザイン＿左
  ctx.moveTo(261, 304) // 左上
  ctx.quadraticCurveTo(265, 288, 265, 288) //
  ctx.quadraticCurveTo(270, 317, 270, 317) //
  ctx.quadraticCurveTo(280, 295, 280, 295) //
  ctx.quadraticCurveTo(285, 341, 285, 341) //
  ctx.quadraticCurveTo(304, 310, 304, 310) //
  ctx.quadraticCurveTo(304, 363, 304, 363) //
  // ギザギザデザイン＿右
  ctx.moveTo(362, 183) // 左上
  ctx.quadraticCurveTo(345, 194, 345, 194) //
  ctx.quadraticCurveTo(365, 204, 365, 204) //
  ctx.quadraticCurveTo(344, 215, 344, 215) //
  ctx.quadraticCurveTo(367, 229, 367, 229) //
  ctx.quadraticCurveTo(345, 245, 345, 245) //
  ctx.quadraticCurveTo(370, 254, 370, 254) //
  ctx.moveTo(347, 112) // 左上
  ctx.quadraticCurveTo(357, 154, 357, 154) //

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  // laceここから
  laceOfDesign(ctx, laceColor, 5, 10)
  laceOfDesign(ctx, laceColor, 17, 15)
  laceOfDesign(ctx, laceColor, 29, 20)
  laceOfDesign(ctx, laceColor, 41, 25)
  laceOfDesign(ctx, laceColor, 53, 30)
  laceOfDesign(ctx, laceColor, 60, 36)
  //
  laceOfDesign(ctx, laceColor, 74, 16)
  laceOfDesign(ctx, laceColor, 75, 0)
  laceOfDesign(ctx, laceColor, 76, -18)
  laceOfDesign(ctx, laceColor, 77, -36)
  laceOfDesign(ctx, laceColor, 78, -54)
  laceOfDesign(ctx, laceColor, 79, -72)
  //
  laceOfDesign(ctx, laceColor, 3, -25)
  laceOfDesign(ctx, laceColor, 15, -20)
  laceOfDesign(ctx, laceColor, 27, -15)
  laceOfDesign(ctx, laceColor, 39, -10)
  //
  laceOfDesign(ctx, laceColor, 55, -30)
  laceOfDesign(ctx, laceColor, 56, -47)
  laceOfDesign(ctx, laceColor, 57, -65)
  laceOfDesign(ctx, laceColor, 58, -98)
  laceOfDesign(ctx, laceColor, 58, -83)
  allowLace1(ctx, laceColor, 10, 60, 0)
  allowLace1(ctx, laceColor, 35, 105, 0)
  laceOfVerticalPartsLeft(ctx, laceColor, 70, -70)
  laceOfVerticalPartsRight(ctx, laceColor, -55, 55)
}

const laceOfDesign = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number) => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  // ウェブ本体
  ctx.beginPath()
  ctx.moveTo(243 + x, 260 + y) // 左上
  ctx.quadraticCurveTo(248 + x, 265 + y, 248 + x, 265 + y) // 左下
  ctx.quadraticCurveTo(258 + x, 254 + y, 261 + x, 245 + y) // 右下
  ctx.quadraticCurveTo(256 + x, 241 + y, 256 + x, 241 + y) // 右上
  ctx.quadraticCurveTo(243 + x, 260 + y, 243 + x, 260 + y) // 左下
  ctx.fill()
  ctx.moveTo(243 + x, 260 + y) // 左上
  ctx.quadraticCurveTo(246 + x, 263 + y, 257 + x, 242 + y) // 左下
  ctx.stroke()
  ctx.closePath()
}

const allowLace1 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number, numerator: number) => {
  ctx.fillStyle = laceColor
  ctx.strokeStyle = '#282828'
  ctx.save()
  ctx.rotate((numerator * Math.PI) / 180)
  // 右側
  ctx.beginPath()
  ctx.moveTo(282 + x, 190 + y) // 左上
  ctx.quadraticCurveTo(282 + x, 194 + y, 285 + x, 198 + y) // 左下1
  ctx.quadraticCurveTo(306 + x, 192 + y, 306 + x, 192 + y) // 右下1
  ctx.quadraticCurveTo(300 + x, 187 + y, 300 + x, 185 + y) // 右上
  ctx.quadraticCurveTo(282 + x, 188 + y, 282 + x, 190 + y) // 左上
  ctx.fill()
  ctx.moveTo(284 + x, 198 + y) // 左上
  ctx.quadraticCurveTo(303 + x, 189 + y, 303 + x, 191 + y) // 右下1
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.moveTo(296 + x, 185 + y) // 左
  ctx.quadraticCurveTo(305 + x, 181 + y, 307 + x, 175 + y) // 右下
  ctx.quadraticCurveTo(301 + x, 169 + y, 301 + x, 169 + y) // 右上
  ctx.quadraticCurveTo(296 + x, 172 + y, 292 + x, 187 + y) // 左上
  ctx.quadraticCurveTo(296 + x, 185 + y, 296 + x, 185 + y) //
  ctx.fill()
  ctx.moveTo(296 + x, 185 + y) // 左上
  ctx.quadraticCurveTo(303 + x, 177 + y, 307 + x, 175 + y) // 右下
  ctx.stroke()
  ctx.closePath()
  ctx.restore()
}

const laceOfVerticalPartsLeft = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.lineWidth = 0.8
  ctx.beginPath()
  ctx.moveTo(265 + x, 208 + y) // 右上
  ctx.quadraticCurveTo(268 + x, 217 + y, 253 + x, 234 + y) // 左上
  ctx.quadraticCurveTo(252 + x, 238 + y, 257 + x, 240 + y) // 左下
  ctx.quadraticCurveTo(275 + x, 227 + y, 265 + x, 208 + y) // 右上
  ctx.fill()
  // 上側面
  ctx.moveTo(265 + x, 208 + y) // 右上
  ctx.quadraticCurveTo(270 + x, 221 + y, 253 + x, 236 + y) // 左下
  ctx.stroke()
  ctx.closePath()
}
